import { ServiceStoreConfig } from "./types/ServiceStoreTypes";

// Import categorized service stores
import { aiStores } from "./serviceStores/ai.stores";
import { authStores } from "./serviceStores/auth.stores";
import { batchingStores } from "./serviceStores/batching.stores";
import { communicationStores } from "./serviceStores/communication.stores";
import { crmStores } from "./serviceStores/crm.stores";
import { deliveryStores } from "./serviceStores/delivery.stores";
import { departmentStores } from "./serviceStores/department.stores";
import { dispatchStores } from "./serviceStores/dispatch.stores";
import { fieldStores } from "./serviceStores/field.stores";
import { financialStores } from "./serviceStores/financial.stores";
import { fleetStores } from "./serviceStores/fleet.stores";
import { iotStores } from "./serviceStores/iot.stores";
import { jobStores } from "./serviceStores/job.stores";
import { manufacturingStores } from "./serviceStores/manufacturing.stores";
import { ordersStores } from "./serviceStores/orders.stores";
import { organizationDataStores } from "./serviceStores/organization-data.stores";
import { pdfEditorStores } from "./serviceStores/pdf-editor.stores";
import { qualityStores } from "./serviceStores/quality.stores";
import { reportingStores } from "./serviceStores/reporting.stores";
import { schedulingStores } from "./serviceStores/scheduling.stores";
import { systemStores } from "./serviceStores/system.stores";
import { userStores } from "./serviceStores/user.stores";
import { yardStores } from "./serviceStores/yard.stores";
import { uncategorizedStores } from "./serviceStores/uncategorized.stores";

/**
 * Main Service Store Configuration
 * Combines all categorized service stores into a single array
 * Optimized for ReadyMix batch plant operations
 *
 * Categories are organized based on the api-types directory structure:
 * - AI: AI services (OpenAI, NLP, RAG, etc.)
 * - Auth: Authentication, activation, password reset
 * - Batching: Batch plants, tickets, materials, mix designs
 * - Communication: Chat, support tickets, RFI, submittals
 * - CRM: Accounts, contacts, opportunities, orders
 * - Delivery: Delivery tickets and routes
 * - Department: Organization structure
 * - Dispatch: Load and trailer management
 * - Field: Field operations, issues, warranty claims
 * - Financial: Invoicing, billing, change orders, PO approvals
 * - Fleet: Drivers, trucks, inspections, maintenance
 * - IoT: Azure IoT Hub, plant sensors
 * - Job: Project and job management
 * - Manufacturing: Materials management, QC, NCR
 * - Orders: Customer order management
 * - Organization Data: List tracker
 * - PDF Editor: Document management
 * - Quality: Compression tests, material tests, QC, slump tests
 * - Reporting: Production reports, utilization reports
 * - Scheduling: Schedule generation, holidays
 * - System: API services, Azure blob storage
 * - User: User management, certifications, training
 * - Yard: Yard inventory and management
 * - Uncategorized: Services without api-types yet
 */
const serviceStores: ServiceStoreConfig[] = [
  // AI Services
  ...aiStores,

  // Auth Services
  ...authStores,

  // Batching Services
  ...batchingStores,

  // Communication Services
  ...communicationStores,

  // CRM Services
  ...crmStores,

  // Delivery Services
  ...deliveryStores,

  // Department Services
  ...departmentStores,

  // Dispatch Services
  ...dispatchStores,

  // Field Services
  ...fieldStores,

  // Financial Services
  ...financialStores,

  // Fleet Services
  ...fleetStores,

  // IoT Services
  ...iotStores,

  // Job Services
  ...jobStores,

  // Manufacturing Services
  ...manufacturingStores,

  // Orders Services
  ...ordersStores,

  // Organization Data Services
  ...organizationDataStores,

  // PDF Editor Services
  ...pdfEditorStores,

  // Quality Services
  ...qualityStores,

  // Reporting Services
  ...reportingStores,

  // Scheduling Services
  ...schedulingStores,

  // System Services
  ...systemStores,

  // User Services
  ...userStores,

  // Yard Services
  ...yardStores,

  // Uncategorized Services (no api-types directory yet)
  ...uncategorizedStores,
];

export default serviceStores;